/**
 * Rct Theme Provider
 */
import {MuiThemeProvider} from '@material-ui/core/styles';
import React, {Fragment} from 'react';
import {connect} from 'react-redux';
// App locale
import dangerTheme from './themes/dangerTheme';
import darkTheme from './themes/darkTheme';
import infoTheme from './themes/infoTheme';
// themes
import primaryTheme from './themes/primaryTheme';
import secondaryTheme from './themes/secondaryTheme';
import successTheme from './themes/successTheme';
import warningTheme from './themes/warningTheme';

const ReactProviders = ({darkMode, rtlLayout, activeTheme, children}) => {
    // theme changes
    let theme = '';
    switch (activeTheme.id) {
        case 1:
            theme = primaryTheme;
            break;
        case 2:
            theme = secondaryTheme;
            break;
        case 3:
            theme = warningTheme;
            break;
        case 4:
            theme = infoTheme;
            break;
        case 5:
            theme = dangerTheme;
            break;
        case 6:
            theme = successTheme;
            break;
        default:
            break;
    }

    if (darkMode) {
        theme = darkTheme;
    }

    if (rtlLayout) {
        theme.direction = 'rtl';
    } else {
        theme.direction = 'ltr';
    }

    return (
        <MuiThemeProvider theme={theme}>
            <Fragment>{children}</Fragment>
        </MuiThemeProvider>
    );
};

// map state to props
const mapStateToProps = ({settings}) => {
    return settings;
};

export default connect(mapStateToProps)(ReactProviders);
